import { render, staticRenderFns } from "./customCounts.vue?vue&type=template&id=436444d7&scoped=true&"
import script from "./customCounts.vue?vue&type=script&lang=js&"
export * from "./customCounts.vue?vue&type=script&lang=js&"
import style0 from "./customCounts.vue?vue&type=style&index=0&id=436444d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436444d7",
  null
  
)

component.options.__file = "customCounts.vue"
export default component.exports